import YesOrNoCheckbox from "../../molecules/yesornocheckbox/YesOrNoCheckbox";
import LabelAndTextBox from "../../molecules/labelandtextbox/LabelAndTextBox";
import { SelfControlWeatherProtectionContainerModel } from "../../../api";
import "./SelfControlWeatherProtectionContainer.css";
import SelfControlWeatherProtectionCard from "../../molecules/selfcontrolweatherprotectioncard/SelfControlWeatherProtectionCard";

interface SelfControlWeatherProtectionContainerProp {
    projectId: number,
    selfControlWeatherProtectionContainer: SelfControlWeatherProtectionContainerModel,
    setSelfControlWeatherProtectionContainer?: React.Dispatch<React.SetStateAction<SelfControlWeatherProtectionContainerModel | null | undefined>>;
    onUpdate: () => void
}

const SelfControlWeatherProtectionContainer: React.FC<SelfControlWeatherProtectionContainerProp> = (props) => {

    const handleChange = (updatedData: Partial<SelfControlWeatherProtectionContainerModel>) => {
        const newObject = { ...props.selfControlWeatherProtectionContainer, ...updatedData };
        props.setSelfControlWeatherProtectionContainer?.(newObject);
        props.onUpdate();
    };

    const handleItemChange = (index: number, updatedItem: any) => {
        const newItems = [...(props.selfControlWeatherProtectionContainer.selfControlItems ?? [])];
        newItems[index] = { ...newItems[index], ...updatedItem };
        handleChange({ selfControlItems: newItems });
    };

    return (
        <div>
            {(props.selfControlWeatherProtectionContainer?.selfControlItems ?? []).map((item: any, index: number) => (
                <SelfControlWeatherProtectionCard
                    projectId={props.projectId}
                    key={`selfControlWeatherProtectionContainer${index}`}
                    selfControlWeatherProtectionItem={item}
                    onUpdate={(updatedItem) => handleItemChange(index, updatedItem)} />
            ))}
            <div className="horizontal-checkboxes">
                <YesOrNoCheckbox
                    approved={props.selfControlWeatherProtectionContainer?.samplingProtocolAttached}
                    onChange={(value) => handleChange({ samplingProtocolAttached: value })}
                    radioGroup="förankringUpplag"
                    title="FÖRANKRING UPPLAG" />
            </div>
            <LabelAndTextBox
                remark={props.selfControlWeatherProtectionContainer?.otherThingsToNote}
                onChange={(value) => handleChange({ otherThingsToNote: value })}
                title="ÖVRIGT ATT NOTERA" />
        </div>
    )
}

export default SelfControlWeatherProtectionContainer;
